import API from '../../api/checkpoints'

const store = {
  namespaced: true,
  state: () => ({
    items: [],
    item: {}
  }),
  mutations: {
    set(state, items) {
      state.items = items
    },
    show(state, item) {
      state.item = item
    }
  },
  actions: {
    async fetch(context, query) {
      let items = await API.list(query)
      items = items.map(item => {
        if (Date.parse(item.date) != NaN) {
          item._date = item.date && new Date(item.date).toInputDateFormat()
        }
        return item
      })
      context.commit('set', items)
    },
    async show(context, id) {
      const item = await API.show(id)
      item.motorbike = item.motorbike && item.motorbike._id
      context.commit('show', item)
    },
    async edit(context, { id, data }) {
      const item = await API.edit(id, data)
      context.commit('show', item)
    },
    async create(context, data) {
      const device = await API.create(data)
      context.commit('show', device)
    },
    async delete(context, id) {
      await API.delete(id)
      context.commit('show', {})
    }
  },
  getters: {
    items: state => {
      return state.items
    },
    item: state => {
      return state.item
    }
  }
}

export default store